export default {
    typeAction: {
        1: 'netSignList', // 网点签收
        2: 'finalSignList', // 用户（终端）签收2B
        3: 'inboundList', // 网点入库
        4: 'outboundList', // 网点出库
        9: 'eleSignList', // 用户签收250
        11: 'signConfirmList' // 签收审核300
    }
};
